import { c as _c } from "react/compiler-runtime";
import Head from 'next/head';
import { serializeStructuredData } from '@/utils/seo/schema.js';
const StructuredData = t0 => {
  const $ = _c(7);
  const {
    data,
    id
  } = t0;
  if (!data) {
    return null;
  }
  let t1;
  if ($[0] !== data) {
    t1 = serializeStructuredData(data);
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      __html: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== id || $[5] !== t2) {
    t3 = <Head><script id={id} type="application/ld+json" dangerouslySetInnerHTML={t2} /></Head>;
    $[4] = id;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default StructuredData;